module.exports = __webpack_public_path__ + "static/img/yytx07.0dd5823.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx07.png
// module id = 787
// module chunks = 0